<template>
  <v-navigation-drawer permanent fixed v-bind:class="classObject">
    <v-list dense nav>
      <v-list-item
        v-for="item in items"
        :key="item.title"
        link
        :to="{ path: '/settings/' + item.link }"
      >
        <v-list-item-icon>
          <v-icon>{{ item.icon }}</v-icon>
        </v-list-item-icon>
        <v-list-item-content>
          <v-list-item-title>{{ item.title }}</v-list-item-title>
        </v-list-item-content>
      </v-list-item>
    </v-list>
  </v-navigation-drawer>
</template>
 
<script>
export const LIGHTS_OUT = "lights-out";

export default {
  data: () => ({
    items: [
      { title: "SSH Keys", icon: "fas fa-key", link: "ssh" },
      { title: "Documentation", icon: "fas fa-file", link: "docs" },
    ],
    isDarkMode: false,
    pathName: window.location.pathname,
  }),
  computed: {
    classObject() {
      return this.isDarkMode && this.pathName === "/settings/docs"
        ? ["navigation", "navigation-dark"]
        : "navigation";
    },
  },
  watch: {
    $route() {
      this.pathName = window.location.pathname;
    },
  },
  methods: {
    readStorage() {
      const lightsOut = localStorage.getItem(LIGHTS_OUT);
      this.isDarkMode = lightsOut === "true";
    },
  },
  mounted() {
    window.addEventListener("storage", (e) => {
      if (e.key === LIGHTS_OUT) {
        this.isDarkMode = e.newValue === "true";
      }
    });
    this.readStorage();
  },
};
</script>
 
<style scoped>
.navigation-dark {
  background-color: darkgrey;
}
</style>